import { Navigate, useRoutes } from 'react-router-dom';
import Callback from './components/Callback';
import Layout from './components/layout/Layout';
import Map from './components/map/Map';
import Table from './components/table/Table';
import LoadingScreen from './components/layout/LoadingScreen';
import TableIndex from './components/table/TableIndex';
import Homepage from './components/Homepage';
import UserPermissionPage from './components/UserPermissionPage';

export default function Router() {
    return useRoutes([
        // { path: '', element: <Navigate to="loading" replace/> },
        { path: '', element: <Homepage /> },
        { path: 'loading', element: <LoadingScreen />},
        { path: 'permission', element: <UserPermissionPage />},
        // { path: '', element: <Navigate to="monitor/map" replace/> },
        {
            path: 'monitor',
            element: <Layout />,
            children: [
                { path: 'map',  element: <Map />},
                { path: 'table',  element: <Table />},
                { path: 'tableindex',  element: <TableIndex />},
            ]
        },
        { path: '/callback', element: <Callback /> },
        // { path: '/404', element: <NotFound404 /> },
        // { path: '/*', element: <Navigate to="/404" replace /> }
    ]);
}